import { CssBaseline } from '@mui/material';
import { BackdropLoader } from 'components/@shared/Loaders';
import { useInitialization } from 'hooks/useInitialization';
import { useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { router } from 'routes/router';
import { getInitIsLoading } from 'store/session/selectors';

export const App = () => {
    const isLoading = useSelector(getInitIsLoading);

    useInitialization();

    if (isLoading) {
        return <BackdropLoader isHiddenText />;
    }

    return (
        <>
            <CssBaseline />
            <RouterProvider router={router} />
        </>
    );
};
